import axios from 'axios'
import qs from 'qs'

const client = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL ?? '/api/v1',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  // No cookies — the admin SPA authenticates with bearer tokens only.
  withCredentials: false,
  timeout: 10000,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true }),
  },
})

// Attach the stored bearer token to every request.
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('startline_admin_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default client
